if(!customElements.get('bundle-builder')) {
  class BundleBuilder extends HTMLElement {
  	constructor() {
      super();

      function handleize(str) {
        return String(str || '')
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, "");
      }

      if (!document.body.classList.contains('has-bundle-builder')) {
        document.body.classList.add('has-bundle-builder');
      }

      var config = {
        bundleContainer: this, //bundle box selector
        items: document.querySelectorAll(this.dataset.itemsSelector), //items selector,
        bundleMinItems: parseInt(this.dataset.bundleMinItems), //global minimum required quantity of items in the bundle
        bundleMaxItems: parseInt(this.dataset.bundleMaxItems), //global limit of items in the bundle, 0=no limit
        groupItems: this.dataset.groupItems=='true', // true, or false to view 1 unit item,
        cartBundleMode: this.dataset.cartBundleMode, // "grouped" or "individual",
        showItemsPlaceholder: this.dataset.showItemsPlaceholder=='true',
        stepsContainer: document.querySelector(this.dataset.stepsContainerSelector),
        bundleName: handleize(this.dataset.bundleName || '')
      }
      //nav & panels behavior
      var btnNavClickHandler = ()=>{};
      if (config.stepsContainer.dataset.navMode == 'step_by_step' || config.stepsContainer.dataset.navMode == 'show_tabs') {
        btnNavClickHandler = function() {
          var switchPanel = true;
          var oldActiveButton = config.stepsContainer.querySelector('.step-nav.active');
          var oldActiveStep = oldActiveButton.dataset.step/1;
          var newStep = this.dataset.step/1;
          if (this.classList.contains('active')) {
            //don't switch if it is the active panel;
            switchPanel = false;
          }
          if (switchPanel) {
            var oldActivePanel = config.stepsContainer.querySelector('.step.active');
            var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
            oldActiveButton.classList.remove('active');
            oldActivePanel.classList.remove('active');
            this.classList.add('active');
            newActivePanel.classList.add('active');

          }
        }
      } else {
        btnNavClickHandler = function() {
          var newStep = this.dataset.step/1;
          var newActivePanel = config.stepsContainer.querySelector('.step[data-step="'+newStep+'"]');
          var header = document.querySelector('header');
          var headerIsVisible = header && header.classList && header.classList.contains('header-sticky') && !header.classList.contains('header-hidden');
          var headerHeight = headerIsVisible ? header.getBoundingClientRect().height : 0;
          var nav = config.stepsContainer.querySelector('.nav');
          var navHeight = nav ? nav.getBoundingClientRect().height : 0;
          var buffer = 16;
          var offset = Math.round(headerHeight + navHeight + buffer);
          $s.scrollToElement(newActivePanel, offset);
        }
      }
      config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn) {
        btn.addEventListener('click', btnNavClickHandler)
      });

      /* start of builder */
      var bundlerInstance = (function(config) {
        var self = {};
        var container = config.bundleContainer;
        var bundleConfigScript = container.querySelector('script[type="application/json"][data-bundle-builder-config]');
        if (!bundleConfigScript) {
          bundleConfigScript = container.querySelector('script[type="application/json"]');
        }
        self.dataJson = JSON.parse(bundleConfigScript.textContent);
        self.stats = {count: 0, total: 0, discount_code: '', incomplete_products_steps: []};

        //quick view integration for bundle builder cards
        var quickViewCtx = {active: false, originItem: null, observer: null};
        var getVisibleModal = function() {
          return document.querySelector('.tingle-modal--visible');
        }
        var getBundleButtonLabel = function() {
          return (window.lngg && window.lngg.bundle_builder_add_to_bundle_button) ? window.lngg.bundle_builder_add_to_bundle_button : 'ADD TO BUNDLE';
        }
        var stripTrailingZeroCents = function(moneyString) {
          if (moneyString === null || moneyString === undefined) return '';
          var s = String(moneyString);
          return s.replace(/\.00(?=[^\d]|$)/, '');
        }
        var formatMoneyBundle = function(cents) {
          return stripTrailingZeroCents($s.formatMoney(cents));
        }
        var getVariantIdFromModal = function(modal) {
          var input = modal.querySelector('form [name="id"]');
          return input && input.value ? input.value / 1 : null;
        }
        var getQtyFromModal = function(modal) {
          var input = modal.querySelector('form [name="quantity"]');
          var qty = input && input.value ? input.value / 1 : 1;
          return qty && qty > 0 ? qty : 1;
        }
        var hidePairsAndSets = function(modal) {
          modal.querySelectorAll('.pairs-with, .sets-content, .metafield-products-tabs').forEach(function(el) {
            el.style.display = 'none';
          });
        }
        var installAddToBundleButton = function(modal) {
          if (!quickViewCtx.originItem) return;
          modal.classList.add('bundle-builder-quick-view');
          hidePairsAndSets(modal);

          modal.querySelectorAll('product-buttons').forEach(function(buttons) {
            var submitBtn = buttons.querySelector('button.btn.add[type="submit"]');
            if (!submitBtn) return;

            //hide the real submit so it can't add to cart
            submitBtn.style.display = 'none';

            //avoid duplicating if modal re-renders
            if (buttons.querySelector('button.bundle-builder-qv-add')) return;

            var clone = submitBtn.cloneNode(true);
            clone.setAttribute('type', 'button');
            clone.classList.add('bundle-builder-qv-add');
            clone.style.display = '';

            var standart = clone.querySelector('.standart');
            if (standart) {
              standart.textContent = getBundleButtonLabel();
            } else {
              clone.textContent = getBundleButtonLabel();
            }

            clone.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();

              var modalEl = e.currentTarget.closest('.tingle-modal');
              var variantId = getVariantIdFromModal(modalEl);
              if (!variantId) return;
              var qty = getQtyFromModal(modalEl);

              self.add(variantId, qty, quickViewCtx.originItem);
              self.updateUI(quickViewCtx.originItem.step || 1);

              var closeBtn = modalEl.querySelector('.tingle-modal__close');
              if (closeBtn) closeBtn.click();

              quickViewCtx.active = false;
              quickViewCtx.originItem = null;
              if (quickViewCtx.observer) {
                quickViewCtx.observer.disconnect();
                quickViewCtx.observer = null;
              }
            }, true);

            submitBtn.insertAdjacentElement('afterend', clone);
          });
        }
        var watchQuickViewModal = function() {
          if (quickViewCtx.observer) return;
          quickViewCtx.observer = new MutationObserver(function() {
            if (!quickViewCtx.active) return;
            var modal = getVisibleModal();
            if (!modal) return;
            if (!modal.querySelector('button.btn.add')) return;
            installAddToBundleButton(modal);
          });
          quickViewCtx.observer.observe(document.documentElement, {subtree: true, childList: true});
        }

        document.addEventListener('click', function(e) {
          var trigger = e.target.closest && e.target.closest('.bundle-builder-section .product-card.bundle-card .quick-view-trigger');
          if (!trigger) return;
          var originItem = trigger.closest('product-card-atc');
          if (!originItem) return;
          if (!config.stepsContainer.contains(originItem)) return;

          quickViewCtx.active = true;
          quickViewCtx.originItem = originItem;
          watchQuickViewModal();
          setTimeout(function() {
            if (!quickViewCtx.active) return;
            var modal = getVisibleModal();
            if (!modal) {
              quickViewCtx.active = false;
              quickViewCtx.originItem = null;
              if (quickViewCtx.observer) {
                quickViewCtx.observer.disconnect();
                quickViewCtx.observer = null;
              }
            }
          }, 5000);

          //fallback poll in case modal content arrives without DOM mutations we catch
          var tries = 0;
          var interval = setInterval(function() {
            tries++;
            if (!quickViewCtx.active) {
              clearInterval(interval);
              return;
            }
            var modal = getVisibleModal();
            if (modal && modal.querySelector('button.btn.add')) {
              installAddToBundleButton(modal);
              if (modal.querySelector('button.bundle-builder-qv-add')) {
                clearInterval(interval);
              }
            }
            if (tries > 80) {
              clearInterval(interval);
            }
          }, 50);
        }, true);


        var itemsAdded = [];
        var uniqIndex = 1;
        var uniq = function() {
          return 'k-' + uniqIndex++;
        }
        var variantUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.variant_id && currentStep == y.step  ? y.quantity : 0), 0);
        }
        var productUnits = function(id, currentStep) {
          return itemsAdded.reduce((x,y)=>x + (id == y.product_id && currentStep == y.step ? y.quantity : 0), 0);
        }
        var totalUnitsInStep = function(currentStep) {
          return itemsAdded.reduce((sum, x)=>sum + (x.step == currentStep ? x.quantity : 0), 0);
        }
        var totalUnitsAllSteps = function() {
          return itemsAdded.reduce((sum, x)=>sum + x.quantity, 0);
        }
        var clamp = function(n, min, max) {
          return Math.min(Math.max(n, min), max);
        }
        self.changeQuantityByKey = function(key, delta) {
          var index = itemsAdded.findIndex((x)=>x.key==key);
          if (index === -1) return;
          var item = itemsAdded[index];
          if (!item || item.bundle_items_required) return;
          var currentStep = item.step || 1;
          var stepConfig = self.dataJson.products_steps[currentStep-1] || {};
          var nextQty = (item.quantity || 0) + delta;
          if (nextQty <= 0) {
            item.quantity = 0;
            self.drawItem(item);
            itemsAdded.splice(index, 1);
            self.updateUI(currentStep);
            return;
          }

          // enforce limits (best-effort; UI still revalidates via updateUI)
          var maxAllowed = Infinity;
          if (config.bundleMaxItems > 0) {
            var currentTotal = totalUnitsAllSteps();
            maxAllowed = Math.min(maxAllowed, (item.quantity || 0) + Math.max(0, config.bundleMaxItems - currentTotal));
          }
          if (stepConfig.max_items > 0) {
            var currentStepTotal = totalUnitsInStep(currentStep);
            maxAllowed = Math.min(maxAllowed, (item.quantity || 0) + Math.max(0, stepConfig.max_items - currentStepTotal));
          }
          if (stepConfig.item_limit > 0) {
            var currentVariantTotal = variantUnits(item.variant_id, currentStep);
            maxAllowed = Math.min(maxAllowed, (item.quantity || 0) + Math.max(0, stepConfig.item_limit - currentVariantTotal));
          }
          if (stepConfig.product_limit > 0) {
            var currentProductTotal = productUnits(item.product_id, currentStep);
            maxAllowed = Math.min(maxAllowed, (item.quantity || 0) + Math.max(0, stepConfig.product_limit - currentProductTotal));
          }

          nextQty = clamp(nextQty, 1, maxAllowed);
          if (nextQty === item.quantity) return;
          item.quantity = nextQty;
          self.drawItem(item);
          self.updateUI(currentStep);
        }
        self.getItemsAddedSnapshot = function() {
          return itemsAdded.slice();
        }
        self.removeLinesBySetOriginProductId = function(setOriginProductId) {
          if (setOriginProductId === undefined || setOriginProductId === null || setOriginProductId === '') return;
          var sid = String(setOriginProductId);
          var lastStep = 1;
          var touched = false;
          for (var ix = itemsAdded.length - 1; ix >= 0; ix--) {
            if (String(itemsAdded[ix].setOriginProductId || '') !== sid) continue;
            touched = true;
            var rmItem = itemsAdded[ix];
            lastStep = rmItem.step || 1;
            rmItem.quantity = 0;
            self.drawItem(rmItem);
            itemsAdded.splice(ix, 1);
          }
          if (touched) {
            self.updateUI(lastStep);
          }
        }
        self.addLineFromPayload = function(payload) {
          var variantId = payload.variantId / 1;
          var quantity = payload.quantity && payload.quantity > 0 ? payload.quantity / 1 : 1;
          var productJson = payload.productJson;
          var title = payload.title || (productJson && productJson.title) || '';
          var imageHtml = payload.imageHtml || '';
          var step = payload.step ? payload.step / 1 : 1;
          var setOriginProductId = payload.setOriginProductId;
          if (!productJson || !productJson.variants) return;
          var variant = productJson.variants.find((x)=>x.id==variantId);
          if (!variant) return;
          var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
          var item;
          if (config.groupItems && index != -1) {
            item = itemsAdded[index];
            item.quantity += quantity;
            if (setOriginProductId !== undefined) item.setOriginProductId = setOriginProductId;
          } else {
            item = {
              variant_id: variantId,
              quantity: quantity,
              key: uniq(),
              product_id: String(productJson.id),
              title: title,
              image: imageHtml,
              variant: variant,
              productData: productJson,
              step: step,
              setOriginProductId: setOriginProductId
            };
            itemsAdded.push(item);
          }
          self.drawItem(item);
        }
        self.applyStartWithSet = function(setOriginProductId, lines) {
          if (!lines || !lines.length) return;
          self.removeLinesBySetOriginProductId(setOriginProductId);
          lines.forEach(function(line) {
            self.addLineFromPayload(line);
          });
          var step = lines[0].step ? lines[0].step / 1 : 1;
          self.updateUI(step);
        }
        self.add = function(variantId, quantity, htmlItem) {
          var index = itemsAdded.map((x)=>x.variant_id).lastIndexOf(variantId);
          var item;
          if (config.groupItems && index != -1) {
            item = itemsAdded[index];
            item.quantity += quantity
          } else {
            var json = JSON.parse(htmlItem.querySelector('[type="application/json"][data-product-json]').textContent);
            item = {
              variant_id: variantId,
              quantity: quantity,
              key: uniq(),
              product_id: htmlItem.dataset.productId,
              title: htmlItem.querySelector('.title').innerText,
              image: htmlItem.querySelector('.img.main').outerHTML,
              variant: json.variants.find((x)=>x.id==variantId),
              productData: json,
              step: htmlItem.step
            };
            itemsAdded.push(item);
          }
          self.drawItem(item);
          
        }
        self.remove = function(variantId, removeQuantity, currentStep) {
          var index = itemsAdded.map((x)=>{return currentStep==x.step ? x.variant_id : 0}).lastIndexOf(variantId);
          self.removeByIndex(index, removeQuantity);
        }
        self.removeAllVariantInStep = function(variantId, step) {
          var idStr = String(variantId);
          var stepNum = Number(step);
          for (var i = itemsAdded.length - 1; i >= 0; i--) {
            if (String(itemsAdded[i].variant_id) === idStr && Number(itemsAdded[i].step) === stepNum) {
              var line = itemsAdded[i];
              self.removeByIndex(i, line.quantity);
            }
          }
        }
        self.removeByKey = function(key) {
          var index = itemsAdded.findIndex((x)=>x.key==key);
          var item = itemsAdded[index];
          self.removeByIndex(index, item.quantity);
        }
        self.removeByIndex = function(index, removeQuantity) {
          var item = itemsAdded[index];
          item.quantity -= removeQuantity;
          if (item.quantity == 0) {
            itemsAdded.splice(index, 1);
          }
          self.drawItem(item);
        }
        self.drawItem = function(item) {
          var itemsContainer = container.querySelector('.bundle-items');
          var comparePart = '';
          var isRewardItem = !!item.bundle_items_required;
          var displayPrice = isRewardItem ? 0 : (item.variant?.price || 0);
          if (!isRewardItem && item.variant && item.variant.compare_at_price && item.variant.compare_at_price > item.variant.price) {
            comparePart = '<span class="bundle-item-compare money">' + formatMoneyBundle(item.variant.compare_at_price) + '</span>';
          }
          var variantLine = '';
          if (item.variant && item.variant.title && item.variant.title !== 'Default Title') {
            variantLine = '<div class="bundle-item-variant">' + item.variant.title + '</div>';
          }
          var qtyHtml = isRewardItem ? '' : `
                    <div class="bundle-item-qty-widget" aria-label="Quantity">
                      <button type="button" class="bundle-item-qty-btn minus" aria-label="Decrease quantity">-</button>
                      <span class="bundle-item-qty-value" aria-label="Quantity">${item.quantity}</span>
                      <button type="button" class="bundle-item-qty-btn plus" aria-label="Increase quantity">+</button>
                    </div>
          `;
          var removeLabel = (window.lngg && window.lngg.bundle_builder_remove_item) ? window.lngg.bundle_builder_remove_item : 'Remove';
          var removeHtml = isRewardItem ? '' : `
                <button type="button" class="remove" aria-label="${removeLabel}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">
                    <path d="M3.5 10.5L10.5 3.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
          `;
          var html = `
            <div class="bundle-item" data-key="${item.key}">
              <div class="bundle-item-inner">
                <div class="bundle-item-image-wrap">${item.image}</div>
                <div class="bundle-item-body">
                  <div class="bundle-item-title">${item.title}</div>
                  ${variantLine}
                  <div class="bundle-item-prices">
                    ${comparePart}
                    <span class="bundle-item-price money">${formatMoneyBundle(displayPrice)}</span>
                  </div>
                  ${qtyHtml}
                </div>
                ${removeHtml}
              </div>
            </div>
            `;
          var existingItem = itemsContainer.querySelector('[data-key="' + item.key + '"]');
          if (item.quantity == 0) {
            html = '';
          }
          if (existingItem) {
            existingItem.outerHTML = html;
          } else {
            itemsContainer.insertAdjacentHTML("beforeend", html);
            
          }
          if (html != '' && !isRewardItem) {
            itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"] .remove').addEventListener('click', function() {
              self.removeByKey(item.key);
            });
            var row = itemsContainer.querySelector('.bundle-item[data-key="' + item.key + '"]');
            var minusBtn = row ? row.querySelector('.bundle-item-qty-btn.minus') : null;
            var plusBtn = row ? row.querySelector('.bundle-item-qty-btn.plus') : null;
            if (minusBtn) {
              minusBtn.addEventListener('click', function(e) {
                e.preventDefault();
                self.changeQuantityByKey(item.key, -1);
              });
            }
            if (plusBtn) {
              plusBtn.addEventListener('click', function(e) {
                e.preventDefault();
                self.changeQuantityByKey(item.key, 1);
              });
            }
          }

          self.updateUI(item.step);
        }
        self.clearAll = function() {
          itemsAdded.length = 0;
          var itemsContainer = container.querySelector('.bundle-items');
          if (itemsContainer) itemsContainer.innerHTML = '';
          var formInputs = container.querySelector('.form-inputs');
          if (formInputs) formInputs.innerHTML = '';
          self.updateUI(1);
        }
        self.drawFormInputs = function() {
          //TODO Subscription updates here (replace variant_id, set subscription properties or selling plan value)
          var html = ''
          var bundleId = new Date().getTime() + '-' + Math.floor(Math.random()*9999 + 1000);

          //walk array in reverse order (then cart items order will match what user see in the bundler builder)
          for (var index = itemsAdded.length -1; index>=0; index--) {
            var item = itemsAdded[index];
            var mode = config.cartBundleMode == 'grouped' ? (index==0?'main' : 'related_multiple') : 'individual';
            html += `
              <input type="hidden" name="items[${index}][id]" value="${item.variant_id}">
              <input type="hidden" name="items[${index}][properties[_bundle_id]]" value="${bundleId}">
              <input type="hidden" name="items[${index}][properties[_bundle_item]]" value="${mode}">
              <input type="hidden" name="items[${index}][properties[_bundle_type]]" value="bundle_builder">
              ${config.bundleName ? `<input type="hidden" name="items[${index}][properties[_bundle_name]]" value="${config.bundleName}">` : ``}
              ${item.bundle_items_required ? `<input type="hidden" name="items[${index}][properties[_bundle_reward]]" value="true">` : ``}
              ${item.bundle_items_required ? `<input type="hidden" name="items[${index}][properties[_bundle_items_required]]" value="${item.bundle_items_required}">` : ``}
              <input type="hidden" name="items[${index}][quantity]" value="${item.quantity}">
              `;
              if (config.cartBundleMode == 'grouped') {
                html += `
                <input type="hidden" name="items[${index}][properties[_locked]]" value="quantity">
                  `;
              }
              if (!config.groupItems) {
              html += `
                <input type="hidden" name="items[${index}][properties[_bundle_position]]" value="${index + 1}">
                `;
            }
          }
          container.querySelector('.form-inputs').innerHTML = html;
        }
        self.updateUI = function(currentStep) {
          //TODO Subscription updates here (show discounted price, don't change the variant id)
          var itemsContainer = container.querySelector('.bundle-items');
          var totalCount = itemsAdded.reduce((x,y)=>x + y.quantity, 0);
          var totalPrice = itemsAdded.reduce((x,y)=>x + ((y.bundle_items_required ? 0 : (y.variant?.price || 0)) * y.quantity), 0);
          self.stats.count = totalCount;
          self.stats.total = totalPrice;
          self.stats.discounted_price = '';

          self.dataJson.products_steps.forEach(function(pd_step, stepIx) {
            var currentStep = stepIx + 1;
            var stepConfig = self.dataJson.products_steps[stepIx];
            var stepContainter = config.stepsContainer.querySelector('.step[data-step="'+currentStep+'"]')
            var itemsAddedFromStep = itemsAdded.filter(x=>x.step==currentStep);
            var totalCountInStep = itemsAddedFromStep.reduce((x,y)=>x + y.quantity, 0);
            if (stepContainter) {
              stepContainter.querySelectorAll('.selected-quantity').forEach(x=>x.innerHTML = totalCountInStep);
            }

            var incompleteStepsItemIndex = self.stats.incomplete_products_steps.indexOf(currentStep);
            if (stepConfig.min_items > 0 && totalCountInStep < stepConfig.min_items) {
              if (incompleteStepsItemIndex==-1) {
                self.stats.incomplete_products_steps.push(currentStep);
              }
            } else if (incompleteStepsItemIndex > -1) {
              self.stats.incomplete_products_steps.splice(incompleteStepsItemIndex, 1);
            }

            config.items.forEach(function(item) {
              if (item.step!=currentStep) {
                return;
              }
              var pid = item.dataset.productId;
              var bundleLines = itemsAdded.filter(function(y) {
                return String(y.product_id) === String(pid) && Number(y.step) === Number(currentStep) && y.quantity > 0;
              });
              var currentVariantId = item.querySelector('[data-variant-id]').value;
              var currentVariantUnits = variantUnits(currentVariantId, currentStep);
              var productStepUnits = productUnits(pid, currentStep);
              item.querySelector('input[type="number"]').value = currentVariantUnits;

              var addBtn = item.querySelector('.btn.add');
              if (addBtn) {
                if (currentVariantUnits > 0) {
                  addBtn.classList.add('is-added');
                  addBtn.setAttribute('aria-pressed', 'true');
                } else {
                  addBtn.classList.remove('is-added');
                  addBtn.setAttribute('aria-pressed', 'false');
                }
              }

              //disable/enable MINUS button
              item.querySelectorAll('.quantity-button.minus').forEach(function(element) {
                if (item.querySelector('[type="number"]').value == 0) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
              
              //disable/enable PLUS and ADD buttons
              item.querySelectorAll('.quantity-button.plus, .btn.add').forEach(function(element) {
                var variantInput = item.querySelector('[data-variant-id]')
                var productId = item.dataset.productId;
                var isAddBtn = element.classList.contains('add');
                var shouldDisable = ( (config.bundleMaxItems > 0 && totalCount>=config.bundleMaxItems)
                  || (stepConfig.max_items > 0 && totalCountInStep>=stepConfig.max_items)
                  || (stepConfig.item_limit > 0 && variantUnits(variantInput.value, currentStep) >= stepConfig.item_limit)
                  || (stepConfig.product_limit > 0 && productUnits(productId, currentStep) >= stepConfig.product_limit) );

                if (shouldDisable) {
                  element.setAttribute('disabled', true);
                } else {
                  element.removeAttribute('disabled');
                }
              });
            });

          });

          
          
          //item placeholders
          if (config.showItemsPlaceholder) {
            itemsContainer.querySelectorAll('.item-placeholder').forEach(function(element) {
              element.parentNode.removeChild(element);
            });
            if (config.bundleMinItems > itemsAdded.length) {
              var placeholder = `
                <div class="bundle-item item-placeholder">
                  <div class="bundle-item-inner">
                    <div class="bundle-item-image-wrap"><div class="image-placeholder"></div></div>
                    <div class="bundle-item-body"><div class="info-placeholder"></div></div>
                  </div>
                </div>
                `.repeat(config.bundleMinItems - itemsAdded.length);
              itemsContainer.insertAdjacentHTML('beforeend', placeholder);
            }
          }


          //disable/enable ADD BUNDLE TO CART button if conditions not meet
          var enableAddBundle = true;
          if (self.stats.incomplete_products_steps.length > 0 || (config.bundleMinItems > 0 && totalCount < config.bundleMinItems)) {
            enableAddBundle = false;
          }
          if (enableAddBundle) {
            container.querySelector('.btn.add').removeAttribute('disabled');
          } else {
            container.querySelector('.btn.add').setAttribute('disabled', true);
          }


          //disable/enable step nav buttons after a step not completed
          if (config.stepsContainer.dataset.navMode == 'step_by_step') {
            var firstStepIncomplete = null;
            if (self.stats.incomplete_products_steps.length>0) {
              firstStepIncomplete = Math.min(...self.stats.incomplete_products_steps);
            }
            config.stepsContainer.querySelectorAll('.nav .step-nav').forEach(function(btn, ix) {
              if (firstStepIncomplete && ix+1 > firstStepIncomplete) {
                btn.setAttribute('disabled', true);
              } else {
                btn.removeAttribute('disabled');
              }
            });
          }


          self.updateProgress();
          
          var titleCount = container.querySelector('.bundle-panel-title-count .count');
          if (titleCount) titleCount.innerHTML = totalCount;
          var finalPrice = self.stats.discounted_price ? self.stats.discounted_price : totalPrice;

          var priceEls = container.querySelectorAll('.subtotal .price');
          var priceHtml = `
            ` + (self.stats.discounted_price ? `<span class="retail money"><span class="visually-hidden">${lngg.product__original_price_label}: </span>` + formatMoneyBundle(self.stats.total) + `</span>` : ``) + `
            <span class="deal money">` + (self.stats.discounted_price ? `<span class="visually-hidden">${lngg.product__final_price_label}: </span>` : ``) + formatMoneyBundle(finalPrice) + `</span>
            `;
          priceEls.forEach(function(priceEl) {
            priceEl.innerHTML = priceHtml;
          });
          var addToCartBtn = container.querySelector('.bundle-add-to-cart');
          if (addToCartBtn) {
            var labelBase = (window.lngg && window.lngg.bundle_builder_add_to_cart_button) ? window.lngg.bundle_builder_add_to_cart_button : 'Add to cart';
            addToCartBtn.textContent = labelBase + ' – ' + formatMoneyBundle(finalPrice);
          }
          container.dispatchEvent(new CustomEvent('bundleBuilderItemsUpdated', {
            bubbles: true,
            detail: { itemsAdded: itemsAdded.slice() }
          }));
        }

        self.updateProgress = function() {
          var completedCaption = container.querySelector('.progress-completed');
          var caption = container.querySelector('.bundle-progress-caption');
          if (!self.dataJson.progress_steps || self.dataJson.progress_steps.length === 0) {
            if (completedCaption) completedCaption.innerHTML = '';
            if (caption) caption.innerHTML = '';
            self.stats.discount_code = '';
            self.stats.discounted_price = '';
            return;
          }
          if (self._updatingProgress) return;
          self._updatingProgress = true;
          var steps = self.dataJson.progress_steps;
          var progressType = self.dataJson.progress_type;
          var triggerType = self.dataJson.progress_trigger_type || 'same_as_progress';
          var metricType = triggerType == 'same_as_progress' ? progressType : triggerType;
          var rewardCount = itemsAdded.reduce((sum, x)=>sum + (x.bundle_items_required ? x.quantity : 0), 0);
          var rewardTotal = itemsAdded.reduce((sum, x)=>sum + (x.bundle_items_required ? (x.variant?.price || 0) * x.quantity : 0), 0);
          var currentValue = metricType == 'quantity'
            ? Math.max(0, self.stats.count - rewardCount)
            : Math.max(0, (self.stats.total - rewardTotal) / 100);
          var values = steps.map((step)=>step.value);
          var maxValue = Math.max(...values);

          var progressLongValue = container.querySelector('.progress-value');
          var progressBars = container.querySelectorAll('.progress-bar');

          if (self.dataJson.progress_steps_independent) {
            progressBars.forEach(function(progressBar, ix) {
              var progressValue = progressBar.querySelector('.progress-value');
              var barValue = Math.min(currentValue / values[ix] * 100, 100);
              if (progressValue) progressValue.style.width = barValue + '%';
              var dot = progressBar.querySelector('.progress-dot');
              if (dot) {
                if (barValue==100) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              }
            });
          } else {
            var barValue = Math.min(currentValue / maxValue * 100, 100);
            if (progressLongValue) progressLongValue.style.width = barValue + '%';
            progressBars.forEach(function(progressBar, ix) {
              progressBar.style.width = (values[ix] - (ix==0 ? 0 : values[ix-1]) ) / maxValue * 100 + '%';
              var dot = progressBar.querySelector('.progress-dot');
              if (dot) {
                if (values[ix]<=currentValue) {
                  dot.classList.add('completed');
                } else {
                  dot.classList.remove('completed');
                }
              }
            });
          }

          if (caption) caption.innerHTML = '';
          if (completedCaption) completedCaption.innerHTML = '';
          self.stats.discount_code = '';
          self.stats.discounted_price = '';
          var stepCompletedIndex = -1;
          for (var i=0; i<steps.length; i++) {
              var step = steps[i];
              if (currentValue < step.value) {
                var diff = step.value - currentValue;
                if (caption) {
                  var progressText = step.caption_step_in_progress
                    .replace('[CURRENT_VALUE]', (metricType=='quantity' ? currentValue : $s.formatMoney(currentValue * 100)) )
                    .replace('[VALUE_REQUIRED]', (metricType=='quantity' ? diff : $s.formatMoney(diff * 100)) );
                  if (step.reward_variant_id || step.reward_product_id || step.reward_variant) {
                    progressText += ' and receive one free gift';
                  }
                  caption.innerHTML = progressText;
                }
                break;
              } else {
                stepCompletedIndex = i;
                if (completedCaption) completedCaption.innerHTML = step.caption_step_completed;
                self.stats.discount_code = step.discount_code || '';
                if (step.discount_percentage) {
                  self.stats.discounted_price = self.stats.total * (100 - step.discount_percentage) / 100;
                }
              }
          }

          // auto add reward products for every completed progress step (multiple free rewards can coexist)
          function rewardTierKey(variantId, threshold) {
            return String(variantId) + ':' + String(threshold);
          }
          function rewardThresholdMatches(itemThreshold, stepValue) {
            return Math.abs(Number(itemThreshold) - Number(stepValue)) < 1e-6;
          }

          var desiredRewardTiers = [];
          for (var j = 0; j <= stepCompletedIndex; j++) {
            var st = steps[j];
            if (!st || !st.reward_variant_id) continue;
            desiredRewardTiers.push({
              variantId: st.reward_variant_id / 1,
              threshold: st.value,
              step: st
            });
          }

          for (var rIx = itemsAdded.length - 1; rIx >= 0; rIx--) {
            var rewardItem = itemsAdded[rIx];
            if (!rewardItem.bundle_items_required) continue;
            var stillDesired = desiredRewardTiers.some(function(tier) {
              return rewardItem.variant_id == tier.variantId && rewardThresholdMatches(rewardItem.bundle_items_required, tier.threshold);
            });
            if (!stillDesired) {
              rewardItem.quantity = 0;
              self.drawItem(rewardItem);
              itemsAdded.splice(rIx, 1);
            }
          }

          var seenTierKeys = {};
          desiredRewardTiers.forEach(function(tier) {
            var tierKey = rewardTierKey(tier.variantId, tier.threshold);
            if (seenTierKeys[tierKey]) return;
            seenTierKeys[tierKey] = true;

            var completedStep = tier.step;
            var desiredRewardVariantId = tier.variantId;
            var existingIndex = itemsAdded.findIndex(function(x) {
              return !!x.bundle_items_required && x.variant_id == desiredRewardVariantId && rewardThresholdMatches(x.bundle_items_required, tier.threshold);
            });
            if (existingIndex > -1) {
              itemsAdded[existingIndex].bundle_items_required = completedStep.value;
            } else if (completedStep.reward_variant) {
              var rewardImage = '';
              if (completedStep.reward_product_image_url) {
                var width = completedStep.reward_product_image_width || 160;
                var height = completedStep.reward_product_image_height || 160;
                rewardImage = `<img class="img main" src="${completedStep.reward_product_image_url}" width="${width}" height="${height}" alt="" />`;
              }
              itemsAdded.push({
                variant_id: desiredRewardVariantId,
                quantity: 1,
                key: uniq(),
                product_id: completedStep.reward_product_id,
                title: completedStep.reward_product_title || '',
                image: rewardImage,
                variant: completedStep.reward_variant,
                productData: {variants: [completedStep.reward_variant]},
                step: 1,
                _bundle_items_required: completedStep.value,
                bundle_items_required: completedStep.value
              });
              self.drawItem(itemsAdded[itemsAdded.length - 1]);
            }
          });

          self._updatingProgress = false;
        }

        function setCardVariantIfPossible(htmlItem, desiredVariantId) {
          var script = htmlItem.querySelector('[type="application/json"][data-product-json]');
          if (!script) return null;
          var json;
          try {
            json = JSON.parse(script.textContent);
          } catch (e1) {
            return null;
          }
          if (!json || !json.variants || !json.variants.length) return null;
          var desired = json.variants.find(function(x) { return Number(x.id) === Number(desiredVariantId); });
          var pick = desired && desired.available ? desired : null;
          if (!pick) {
            pick = json.variants.find(function(x) { return x.available; });
          }
          if (!pick) return null;
          var variantInput = htmlItem.querySelector('input[data-variant-id]');
          if (!variantInput) return null;
          if (Number(variantInput.value) !== Number(pick.id)) {
            variantInput.value = String(pick.id);
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return pick.id;
        }

        function getRemainingAddSlots(htmlItem, step, variantId) {
          var stepConfig = self.dataJson.products_steps[step - 1] || {};
          var productId = htmlItem.dataset.productId;
          var totalCount = itemsAdded.reduce(function(s, y) { return s + y.quantity; }, 0);
          var totalCountInStep = itemsAdded.filter(function(y) { return Number(y.step) === Number(step); }).reduce(function(s, y) { return s + y.quantity; }, 0);
          var vUnits = variantUnits(variantId, step);
          var pUnits = productUnits(productId, step);
          var slots = 9999;
          if (config.bundleMaxItems > 0) slots = Math.min(slots, config.bundleMaxItems - totalCount);
          if (stepConfig.max_items > 0) slots = Math.min(slots, stepConfig.max_items - totalCountInStep);
          if (stepConfig.item_limit > 0) slots = Math.min(slots, stepConfig.item_limit - vUnits);
          if (stepConfig.product_limit > 0) slots = Math.min(slots, stepConfig.product_limit - pUnits);
          return Math.max(0, slots);
        }

        function stripUrlPresetParam(paramName) {
          if (!(window.Shopify && Shopify.designMode)) {
            try {
              var u = new URL(window.location.href);
              u.searchParams.delete(paramName);
              var next = u.pathname + (u.search || '') + (u.hash || '');
              window.history.replaceState({}, '', next);
            } catch (e3) {}
          }
        }

        function tryOpenStartWithSetModalForPreset(preset, done) {
          if (!preset) {
            done(false);
            return;
          }
          var attempts = 0;
          var tick = function() {
            if (window.startWithASet && typeof window.startWithASet.openModalForPreset === 'function' && window.startWithASet.openModalForPreset(preset)) {
              done(true);
              return;
            }
            attempts++;
            if (attempts < 100) {
              setTimeout(tick, 50);
            } else {
              done(false);
            }
          };
          tick();
        }

        var urlPresetHandled = false;

        function tryApplyUrlPresetFromQuery() {
          if (urlPresetHandled) return;
          var sectionId = container.dataset.sectionId;
          if (!sectionId) return;

          var scriptEl = document.getElementById('bundle-builder-url-presets-' + sectionId);
          if (!scriptEl || !scriptEl.textContent) return;

          var cfg;
          try {
            cfg = JSON.parse(scriptEl.textContent);
          } catch (e2) {
            return;
          }

          var paramName = cfg.paramName && String(cfg.paramName).trim();
          if (!paramName) return;
          if (!cfg.presets || !cfg.presets.length) return;

          var params = new URLSearchParams(window.location.search);
          var rawVal = params.get(paramName);
          if (rawVal === null || String(rawVal).trim() === '') return;

          var wanted = String(rawVal).trim();
          var preset = cfg.presets.find(function(p) {
            return p && String(p.value || '').trim() === wanted;
          });
          if (!preset) return;

          var applyPresetLines = function() {
            if (!preset.lines || !preset.lines.length) return;

            var itemsArr = Array.prototype.slice.call(config.items);
            var addedAny = false;
            var lastStep = 1;

            preset.lines.forEach(function(line) {
            var productId = String(line.productId);
            var step = Number(line.step);
            if (!productId || !step) return;

            var htmlItem = itemsArr.find(function(item) {
              return String(item.dataset.productId) === productId && Number(item.step) === step;
            });
            if (!htmlItem) return;

            var vid = setCardVariantIfPossible(htmlItem, line.variantId);
            if (!vid) return;

            var slots = getRemainingAddSlots(htmlItem, step, vid);
            if (slots < 1) return;

            self.add(vid, 1, htmlItem);
            addedAny = true;
            lastStep = step;

            var number = htmlItem.querySelector('input[type="number"]');
            var variantInput = htmlItem.querySelector('input[data-variant-id]');
            if (number && variantInput) {
              number.value = variantUnits(variantInput.value, step);
            }
            });

            if (addedAny) {
              self.updateUI(lastStep);
              urlPresetHandled = true;
            }

            if (addedAny && cfg.replaceState === true) {
              stripUrlPresetParam(paramName);
            }
          };

          tryOpenStartWithSetModalForPreset(preset, function(openedSetModal) {
            if (openedSetModal) {
              urlPresetHandled = true;
              if (cfg.replaceState === true) {
                stripUrlPresetParam(paramName);
              }
              return;
            }
            applyPresetLines();
          });
        }

        function scheduleUrlPresetApply() {
          tryApplyUrlPresetFromQuery();
        }

        function init() {
          container.querySelector('.btn.add').addEventListener('click', function() {
            var add = ()=> {
              self.drawFormInputs();
              var data = new FormData();
              container.querySelector('.form-inputs').querySelectorAll('[name]:checked,[name]:not([type="checkbox"]):not([type="radio"])').forEach(x=>data.append(x.name, x.value));
              $s.post({
                url: '/cart/add.js',
                data: data,
                success: function(){
                  $s.addToCartSuccess();
                  var itemsContainer = container.querySelector('.bundle-items');
                  if (itemsContainer) {
                    itemsContainer.innerHTML = '<div class="bundle-added-flash">Added</div>';
                  }
                  itemsAdded.length = 0;
                  setTimeout(function() {
                    if (itemsContainer) itemsContainer.innerHTML = '';
                    var formInputs = container.querySelector('.form-inputs');
                    if (formInputs) formInputs.innerHTML = '';
                    self.updateUI(1);
                  }, 1200);
                },
                error: function(response){
                  $s.addToCartFail(response.description);
                }
              })
            }
            
            $s.showLoadingOverlay();

            if (self.stats.discount_code) {
              $s.get({url: '/discount/'+self.stats.discount_code, success: add})
            } else {
              add();
            }
          });

          var mobileProductsPanel = container.querySelector('.bundle-mobile-products-panel');
          var mobileEditToggle = container.querySelector('.bundle-mobile-edit-toggle');
          if (mobileEditToggle && mobileProductsPanel) {
            mobileEditToggle.addEventListener('click', function() {
              if (this.getAttribute('aria-expanded')=='false') {
                this.setAttribute('aria-expanded', 'true');
                $s.expand([mobileProductsPanel]);
              } else {
                this.setAttribute('aria-expanded', 'false');
                $s.collapse([mobileProductsPanel]);
              }
            });
          }

          var clearAllBtn = container.querySelector('.bundle-clear-all');
          if (clearAllBtn) {
            clearAllBtn.addEventListener('click', function(e) {
              e.preventDefault();
              self.clearAll();
            });
          }

          config.items.forEach(function(item) {
            //Update input type number starting value and min="0" attribute
            var a = item.querySelector('.product-card-url');
            a.removeAttribute('href');
            var number = item.querySelector('input[type="number"');
            var variantInput = item.querySelector('input[data-variant-id]');
            var addBtn = item.querySelector('.btn.add');
            item.step = item.closest('[data-step]').dataset.step/1;
            var currentStep = item.step;
            var stepConfig = self.dataJson.products_steps[currentStep-1];

            number.setAttribute('min', '0');
            number.value = 0;
            number.setAttribute('disabled', true);
            if (stepConfig.item_limit) {
              number.setAttribute('max', stepConfig.item_limit);
            }

            //Handle quantity change
            number.addEventListener('change', function(event) {
              var diff = this.value - variantUnits(variantInput.value, currentStep);
              if (diff > 0) {
                self.add(variantInput.value, diff, item);
              } else if (diff < 0) {
                self.remove(variantInput.value, Math.abs(diff), item.step);
              }
            });

            //Handle swatch change
            variantInput.addEventListener('change', function(event) {
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            });

            //clear existing events and replace button
            var btnDisplay = addBtn.style.display;
            addBtn.setAttribute('type', 'button');
            addBtn.style.display = btnDisplay;
            addBtn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              var alreadyUnits = variantUnits(variantInput.value, currentStep);
              if (alreadyUnits > 0) {
                self.removeAllVariantInStep(variantInput.value, currentStep);
              } else {
                self.add(variantInput.value, 1, item);
              }
              number.value = variantUnits(variantInput.value, currentStep);
              self.updateUI(currentStep);
            }, true);

        
          })

          self.updateUI(1);
          scheduleUrlPresetApply();
          window.addEventListener('load', scheduleUrlPresetApply);
          document.addEventListener('startWithASetReady', scheduleUrlPresetApply);
        }
        
        init();

        return self;
      })(config);
      this.bundlerApi = bundlerInstance;

    }
  }
  customElements.define('bundle-builder', BundleBuilder);
}
(function() {
  if (!window.$s || window.$s._bundleMegamenuFixInit) {
    return;
  }
  window.$s._bundleMegamenuFixInit = true;

  var html = document.documentElement;
  var overlayTimeoutId = null;

  function setHeaderScrollEnabled(enabled) {
    var headerScroll = document.querySelector('header-scroll');
    if (headerScroll) {
      headerScroll.scrollHandlerEnabled = enabled;
    }
  }

  function clearMegamenuOverlay() {
    if (overlayTimeoutId) {
      clearTimeout(overlayTimeoutId);
    }
    overlayTimeoutId = setTimeout(function() {
      html.classList.remove('megamenu-overlay');
      setHeaderScrollEnabled(true);
    }, 210);
  }

  function initBundleMegaMenuTrigger(obj) {
    if (obj.dataset.bundleMegamenuInit === 'true') {
      return;
    }
    obj.dataset.bundleMegamenuInit = 'true';
    obj.classList.add('submenu-initialized');

    var submenu = obj.querySelector('.submenu');
    if (!submenu) {
      return;
    }

    var menuTrigger = obj.querySelector('a.nav-1, button.nav-1, a, button');
    var lastLinkClicked = null;
    var closeTimer = null;

    function setExpanded(expanded) {
      if (menuTrigger) {
        menuTrigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    function openMenu() {
      if (lastLinkClicked && (Date.now() - lastLinkClicked) <= 300) {
        return;
      }
      clearTimeout(closeTimer);
      closeTimer = null;
      if (overlayTimeoutId) {
        clearTimeout(overlayTimeoutId);
        overlayTimeoutId = null;
      }
      $s.expand([submenu]);
      setExpanded(true);
      html.classList.add('megamenu-overlay');
      html.classList.remove('show-overlay');
      setHeaderScrollEnabled(false);
    }

    function closeMenu() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function() {
        $s.collapse([submenu]);
        setExpanded(false);
        clearMegamenuOverlay();
      }, 250);
    }

    obj.addEventListener('click', function(e) {
      if (e.target.closest('a')) {
        lastLinkClicked = Date.now();
      }
    });
    obj.addEventListener('mouseenter', openMenu);
    obj.addEventListener('mouseleave', closeMenu);
    submenu.addEventListener('mouseenter', function() {
      clearTimeout(closeTimer);
      closeTimer = null;
    });
    submenu.addEventListener('mouseleave', closeMenu);
    obj.addEventListener('keydown', function(e) {
      if (e.which !== 27) {
        return;
      }
      e.preventDefault();
      clearTimeout(closeTimer);
      $s.collapse([submenu]);
      setExpanded(false);
      clearMegamenuOverlay();
      if (menuTrigger) {
        menuTrigger.focus();
      }
    });
  }

  function initBundleMegaMenuTriggers() {
    document.querySelectorAll('.header-main-menu .mega-menu-trigger.has-dropdown:not([data-bundle-megamenu-init="true"])').forEach(initBundleMegaMenuTrigger);
  }

  function isBundleBuilderPage() {
    return document.body.classList.contains('has-bundle-builder') || document.documentElement.classList.contains('bundle-builder-page');
  }

  var originalSetHeaderSubmenus = $s.setHeaderSubmenus;
  $s.setHeaderSubmenus = function() {
    if (!isBundleBuilderPage()) {
      return originalSetHeaderSubmenus.apply(this, arguments);
    }
    initBundleMegaMenuTriggers();
    return originalSetHeaderSubmenus.apply(this, arguments);
  };

  initBundleMegaMenuTriggers();
})();
